import React from 'react';
import PropTypes from 'prop-types';
import _find from 'lodash/find';

import { QueryComponent } from '../../../GraphQL';
import { getMyMockExamResults, MASTER_EXAM_STATUS } from '../../../GraphQL/query/MockExam.query';
import { ExamListTable as ExamListTableView } from '../../../Components/Table';

const flattenArray = (array, field) => {
  const reducer = (acc, currentValue) => {
    return [...acc, currentValue[field]];
  };
  const newArray = Array.isArray(array) ? array.reduce(reducer, []) : [];
  return newArray;
};

const getRow = (data, examCard) => {
  const examCardId = examCard.id;
  const examId = examCard.examId;
  const exam = examCard.exam;
  const examResult = _find(data.mockExamResults, d => d.examId === examId) || {};
  const myExamResult = _find(data.myMockExamResults, d => d.examCardId === examCardId) || {};
  return {
    id: examId,
    subjectCode: exam.subjectCode,
    subjectIcon: exam.iconUrl,
    subject: exam.title,
    released: exam.status !== 'NEW',
    solutionOnly: exam.status === 'KEY_READY',
    averageScore: examResult.averageScore,
    fullScore: examResult.fullScore,
    testerCount: examResult.examAttendee,
    score: myExamResult.score,
    ranking: myExamResult.rank,
    percentile: myExamResult.percentile,
    examCardId: examCard.id,
  };
};

const ExamListTable = ({ title, examCards, ...restProps }) => {
  const resultReadyCards = examCards.filter(
    card => card.exam.status === MASTER_EXAM_STATUS.GRADE_READY,
  );
  const examCardIds = flattenArray(resultReadyCards, 'id');
  const mockExamIds = flattenArray(resultReadyCards, 'examId');
  return (
    <QueryComponent query={getMyMockExamResults} variables={{ examCardIds, mockExamIds }}>
      {data => {
        const rows = examCards.map(examCard => getRow(data, examCard));
        return <ExamListTableView title={title} rows={rows} {...restProps} />;
      }}
    </QueryComponent>
  );
};

ExamListTable.propTypes = {
  examCardIds: PropTypes.array,
  mockExamIds: PropTypes.array,
};

export default ExamListTable;
